import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@bigpp/ui/components/dialog";

import { MOD_KEY } from "../platform.ts";

type Shortcut = { keys: string[]; label: string };

const SHORTCUTS: Shortcut[] = [
  { keys: [MOD_KEY, "K"], label: "Open command palette" },
  { keys: [MOD_KEY, "/"], label: "Show this help" },
  { keys: ["↵"], label: "Send message" },
  { keys: ["⇧", "↵"], label: "Newline in composer" },
  { keys: ["Esc"], label: "Close dialogs / palette" },
  { keys: ["↑", "↓"], label: "Navigate palette entries" },
];

export function KeymapOverlay({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-sm">Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <ul className="flex flex-col gap-1.5 text-xs">
          {SHORTCUTS.map((s) => (
            <li key={s.label} className="flex items-center justify-between gap-3">
              <span className="text-[var(--color-muted-foreground)]">{s.label}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k) => (
                  <kbd
                    key={k}
                    className="font-mono rounded border border-[var(--color-border)] bg-[var(--color-secondary)] px-1.5 py-0.5 text-[10px]"
                  >
                    {k}
                  </kbd>
                ))}
              </span>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
